export default __webpack_public_path__ + "static/media/herbSearch.39d35d03.svg";